import { render, staticRenderFns } from "./UniversityWithFilterSelectbox.vue?vue&type=template&id=28305e56"
import script from "./UniversityWithFilterSelectbox.vue?vue&type=script&lang=js"
export * from "./UniversityWithFilterSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports